import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Ehrliche 404-Seite. Ersetzt den früheren stillen Redirect zum Dashboard,
 * der kaputte Links unsichtbar machte.
 */
export const NotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      minHeight: '60vh',
      textAlign: 'center',
      padding: '2rem',
      color: 'var(--text-primary)',
    }}>
      <div style={{ fontSize: '4rem', fontWeight: 700, opacity: 0.3 }}>404</div>
      <h2 style={{ margin: '0.5rem 0', fontSize: '1.5rem', fontWeight: 600 }}>
        Seite nicht gefunden
      </h2>
      <p style={{ color: 'var(--text-tertiary)', marginBottom: '1.5rem' }}>
        Die aufgerufene Seite existiert nicht oder wurde verschoben.
      </p>
      <button
        onClick={() => navigate('/dashboard')}
        style={{
          padding: '10px 20px',
          background: 'var(--accent-primary, #7c3aed)',
          color: '#fff',
          border: 'none',
          borderRadius: '10px',
          cursor: 'pointer',
          fontWeight: 600,
        }}
      >
        Zurück zum Dashboard
      </button>
    </div>
  );
};

export default NotFound;
